import React, { Component } from 'react'
import { findDOMNode } from 'react-dom';

class ListItem extends Component {
    render() {
        return (
            <li className={(this.props.id % 2 === 0) ? "toggle" : ""} onClick={this.props.onClick}>{this.props.value}</li>
        );
    }
}

class List extends Component {
    render() {
        return (
            <ul className="dropdown__content">
                {
                    this.props.items.map((item, i) => <ListItem key={i} id={i} value={item} onClick={() => this.props.onItemClick(i, item)} />)
                }
            </ul>
        );
    }
}

class Dropdown extends Component {
    constructor(props) {
        super(props);

        this.all_elements = this.props.elements;
        this.all_lower = [];

        for (var i = 0; i < this.all_elements.length; i++) {
            this.all_lower.push(this.all_elements[i].toLowerCase());
        }

        this.state = {
            expanded: false,
            textInput: '',
        }

        this._onWindowClick = this._onWindowClick.bind(this);
    }

    componentDidMount() {
        window.addEventListener('click', this._onWindowClick);
        window.addEventListener('touchstart', this._onWindowClick);
    }

    componentWillUnmount() {
        window.removeEventListener('click', this._onWindowClick);
        window.removeEventListener('touchstart', this._onWindowClick);
    }

    _onWindowClick(event) {
        const dropdownElement = findDOMNode(this);
        if (event.target !== dropdownElement && !dropdownElement.contains(event.target) && this.state.expanded) {
            this.setState({ expanded: false });
        }
    }

    handleItemClick(key, value) {
        let closeAfterClick = true;

        if (typeof this.props.closeAfterClick !== 'undefined')
            closeAfterClick = this.props.closeAfterClick;

        this.props.onValueChange(value);

        this.setState({
            textInput: value,
            expanded: !closeAfterClick,
        });
    }

    render() {
        let trigger;
        let elements = [];
        if (this.props.inputType === "text") {
            trigger = <input className={"Kontakt-form-input" + (this.props.error ? " error" : "")} value={this.state.textInput} onChange={(e) => { this.props.onValueChange(e.target.value); this.setState({ textInput: e.target.value, expanded: (e.target.value.length > 0) ? true : false }); }} onClick={() => this.setState({ expanded: !this.state.expanded })
            } />
            if (this.state.textInput.length > 1) {
                const maxLength = 6;
                let indices = []
                let re1 = new RegExp('^' + this.state.textInput.toLowerCase());
                // Search for exact fit
                for (let i = 0; i < this.all_elements.length; i++) {
                    let match = this.all_lower[i].match(re1);
                    if (match) {
                        elements.push(this.all_elements[i]);
                        indices.push(i);
                        if (elements.length > maxLength) {
                            elements.push('...');
                            break;
                        }
                    }
                }

                let re2 = new RegExp(this.state.textInput.toLowerCase());
                // Search for all possibilities
                for (let i = 0; i < this.all_elements.length; i++) {
                    if (elements.length > maxLength) {
                        break;
                    }

                    if (indices.indexOf(i) >= 0) {
                        continue;
                    }

                    let match = re2.exec(this.all_lower[i]);
                    if (match) {
                        elements.push(this.all_elements[i]);
                        if (elements.length > maxLength) {
                            elements.push('...');
                            break;
                        }
                    }
                }
            }
        }
        // button.
        else {
            trigger = <button className={"Kontakt-form-input" + (this.props.error ? " error" : "")} type="button" onClick={() => this.setState({ expanded: !this.state.expanded })}>{this.state.textInput}</button>
            elements = this.props.elements;
        }
        return (
            <div style={{ display: "inherit", justifySelf: "stretch" }} className={this.state.expanded ? "dropdown--active" : ""}>
                {trigger}
                <List items={elements} onItemClick={(k, v) => this.handleItemClick(k, v)} />
            </div >
        );
    }
}

export default Dropdown


// WEBPACK FOOTER //
// ./src/contact-form/dropdown.js